import React from 'react';
import { UNIT_STATUS_LABELS, OWNER_STATUS_LABELS, UNIT_STATUS_REASONS, UNIT_STATUS_PRESUMED, UNIT_STATUS_PRESUMED_HINT, stoppedBy } from '../config/unitStatusLabels';
import '../styles/UnitStatusPanel.css';

/**
 * The compact «حالة التشغيل» — one word in the status colour, for lists and side panels
 * (properties list, inbox). The unit page uses the full strip (UnitStatusPanel).
 *
 * Renders whatever view the backend shaped: staff get the five statuses (reason in the tooltip,
 * «حسب الموعد» when based on the schedule, not observed), owners the simplified four. `null` renders nothing — a list row whose
 * status did not load stays quiet rather than guessing.
 */
const TONE = {
  OCCUPIED: 'occupied', STOPPED: 'stopped', AWAITING_CLEANING: 'waiting', UNKNOWN: 'unknown',
  READY: 'ready', PREPARING: 'waiting', AVAILABLE: 'ready',
};

const UnitStatusChip = ({ unitStatus, showReason = false }) => {
  if (!unitStatus?.status) return null;
  const isOwner = unitStatus.view === 'owner';
  const label = (isOwner ? OWNER_STATUS_LABELS : UNIT_STATUS_LABELS)[unitStatus.status] || unitStatus.status;
  const reason = isOwner ? null
    : (unitStatus.reasonCode === 'UNIT_STOPPED' && unitStatus.stoppedByName
      ? stoppedBy(unitStatus.stoppedByName)
      : UNIT_STATUS_REASONS[unitStatus.reasonCode]);
  const presumed = !isOwner && unitStatus.confidence === 'PRESUMED';
  return (
    <span className={`unit-status-chip tone-${TONE[unitStatus.status] || 'unknown'}`} title={reason || undefined}>
      <span className="unit-status-chip-dot" aria-hidden="true"></span>
      {label}
      {presumed && <span className="unit-status-chip-presumed" title={UNIT_STATUS_PRESUMED_HINT}>{UNIT_STATUS_PRESUMED}</span>}
      {showReason && reason && <span className="unit-status-chip-reason">— {reason}</span>}
    </span>
  );
};

export default UnitStatusChip;
